export default __webpack_public_path__ + "static/media/upload.9df2cb65.svg";